<template>
  <!-- <div class="quickPurchased" style="display:none;">
    <div class="container clearfix" style="padding:0 !important;">
      <div class="row d-sm-block d-none" style="float:left;padding: 20px;max-width:50%;">
        <img
          class="sm_img"
          :src="(variant_new.feature_image&&variant_new.feature_image.thumbnail)||(product.gallery[0]&&product.gallery[0].thumbnail)||defaultImage"
          @error.once="imageFailure"
          alt
        />
        <div
          class="social-sharing sm_describe"
          style="display:inline-block;vertical-align: middle;max-width:400px"
          @click.stop="$('html,body').animate({scrollTop: '0px'},300);"
        >
          <a style="max-width:400px">{{product.post_title}}</a>
          <p v-if="product.variants&&product.variants.length>1">
            <span v-for="item in $store.state.now_variant.attrs" :key="item.name">{{item.value}}</span>
          </p>
        </div>
      </div>
      <div class="quick_right text-right" style="float:right;padding:8px;max-width:50%;">
        <div class="commoditypricetype d-sm-inline-block d-none" style="display:inline-block;">
          <v-selectprice
            :price="price"
            :font-size="show_currency_selector?16:20"
            :regular-font-size="show_currency_selector?14:17"
            type="reverse"
            :regular_price_num="Number(regular_price)>Number(price)?regular_price:''"
            :disable_select="!show_currency_selector"
            :appendToBody="false"
          ></v-selectprice>
        </div>
        <el-button
          v-if="type==='default'"
          class="gocart secondary_title sm_button main_button"
          type="button"
          native-type="submit"
          :loading="loading"
          :disabled="!stock"
          @click="childMethod()"
          style="background:#000;color:#fff;height:44px;margin:5px;display:inline-block"
          :style="{'opacity':!stock?'0.5':'1' }"
        >{{$t('detail.add_to_cart')}}</el-button>
        <button
          v-if="type==='venue'"
          type="submit"
          name="add"
          :disabled="loading || !stock "
          @click="!loading && childMethod()"
          style="height:44px;margin:5px;display:inline-block;width:200px;"
          class="product_single_add_button secondary_title sm_button main_button"
          :class="loading || !stock ? 'product_single_add_button_disabled':''"
        >
          <span>{{$t('detail.add_to_cart')}}</span>
        </button>
      </div>
    </div>
  </div> -->
  <div class="quickPurchased" style="display: none">
    <div class="container">
      <div class="row align-items-center justify-content-between" :class="{'showtime_quick':type==='showtime'}">
        <div class="quick_left col-md-3 align-items-center">
          <div class="quick_left_img">
            <img
              class="sm_img"
              :src="
                (variant_new.feature_image &&
                  variant_new.feature_image.thumbnail) ||
                (product.gallery[0] && product.gallery[0].thumbnail) ||
                defaultImage
              "
              @error.once="imageFailure"
              alt
            />
          </div>
          <div class="quick_left_content">
            <h2 class="title_font2" @click="$('html,body').animate({ scrollTop: '0px' }, 300)">
              {{ product.post_title }}
            </h2>
            <v-selectprice
              :price="price"
              :font-size="show_currency_selector ? 14 : 16"
              :regular-font-size="show_currency_selector ? 12 : 15"
              type="reverse"
              :regular_price_num="
                Number(regular_price) > Number(price) ? regular_price : ''
              "
              :disable_select="type == 'showtime'?'true':!show_currency_selector"
              :country="type == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
              :appendToBody="false"
            ></v-selectprice>
          </div>
        </div>
        <div class="quick_right col-md-9 align-items-center">
          <div class="product_variants secondary_title" v-if="product.variants&&product.variants.length>1">
            <div
              class="product_variant"
              v-for="(item, index) in variant_attrs"
              :key="'quick' + item.name + index"
            >
              <label class="variant_label" :for="'quick' + item.name + index">{{
                item.name
              }}</label>
              <div class="variant_wrapper">
                <select
                  :id="'quick' + item.name + index"
                  :name="'quick' + item.name + index"
                  v-model="variant[index].value"
                >
                  <option
                    :value="subitem"
                    v-for="(subitem, subindex) in item.value"
                    :key="'quick' + subitem + subindex"
                  >
                    {{ subitem }}
                  </option>
                </select>
              </div>
            </div>
            <div class="quantity"> <input type="number" v-model="quantity" :min="1" :max="100000" @change="change_quantity"></div>
          </div>
          <div class="commoditynum secondary_title">
            <div class="quantity-label">
              {{ $t("detail.quantity") }}
            </div>
            <el-input-number
              v-model="addproduct.quantity"
              :min="1"
              :max="100000"
              :step="1" step-strictly
            ></el-input-number>
          </div>
          <el-button
            v-if="type === 'default'|| type==='showtime'"
            class="gocart secondary_title sm_button main_button secondary_title"
            type="button"
            native-type="submit"
            :loading="loading"
            :disabled="!stock"
            @click="childMethod()"
            style="
              background: #000;
              color: #fff;
              margin: 5px;
              display: inline-block;
            "
            :style="{ opacity: !stock ? '0.5' : '1' }"
            >{{ $t("detail.add_to_cart") }}</el-button
          >
          <button
            v-if="type === 'venue'"
            type="submit"
            name="add"
            :disabled="loading || !stock"
            @click="!loading && childMethod()"
            style="
              margin: 5px;
              display: inline-block;
            "
            class="gocart product_single_add_button secondary_title sm_button main_button secondary_title"
            :class="
              loading || !stock ? 'product_single_add_button_disabled' : ''
            "
          >
            {{ $t("detail.add_to_cart") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultImage from "../../../../../public/images/no-image.gif";
export default {
  props: [
    "quick_add_cart",
    "variant_new",
    "product",
    "price",
    "regular_price",
    "type",
    "loading",
    "stock",
    "show_currency_selector",
    "addproduct",
    "variant_attrs",
    "variant",
  ],
  data() {
    return {
      defaultImage,
      quantity:1
    };
  },
  methods: {
    change_quantity(){
      this.addproduct.quantity=this.quantity;
    },
    handleScroll() {
      // console.log(window.pageYOffset)
      if (window.pageYOffset > 760) {
        this.$(".quickPurchased").slideDown(300);
        this.$(".commonfoot").css(
          "paddingBottom",
          this.$(".quickPurchased").innerHeight() + "px"
        );
      } else {
        this.$(".quickPurchased").slideUp(300);
      }
      // console.log('quick',this.quick);
    },
    imageFailure(e) {
      e.target.src = this.defaultImage;
    },
    childMethod() {
      this.$emit("fatherMethod");
    },
  },
  mounted() {
    if (this.quick_add_cart) {
      document.addEventListener("scroll", this.handleScroll, true);
    }
  },
  watch:{
    addproduct:{
      handler(newV,oldV){
        this.quantity=newV.quantity;
      },
      deep:true
    }
  }
};
</script>

<style lang='scss'>
.quickPurchased {
  width: 100%;
  // height: 70px;
  padding: 15px 0;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.08);
  .container {
    .showtime_quick{
      margin-left: -15px;
      margin-right: -15px;
      .quick_right{
        .product_variants{
          .quantity{
            input{
                margin: 0;
            }
          }
        }
        .commoditynum{
          .el-input-number {
            .el-input {
              .el-input__inner {
                margin: 0;
              }
            }
          }
        }
      }
    }
    .quick_left {
      display: flex;
      padding: 0 12px;
      .quick_left_img {
        width: 68px;
        margin-right: 10px;
        flex-grow: 0;
        flex-shrink: 0;
        img {
          max-width: 100%;
          border: 1px solid #f6f6f6;
        }
      }
      .quick_left_content {
        overflow: hidden;
        margin-left: 10px;
        h2 {
          font-size: 14px;
          color: #1a1a1a;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: uppercase;
          font-weight: 700;
          cursor: pointer;
        }
      }
    }
    .quick_right {
      display: flex;
      justify-content: flex-end;
      .gocart {
        width: 168px;
        margin: 0;
        white-space: initial;
        line-height: 1.1;
      }
      .commoditynum {
        font-size: 15px;
        margin-right: 24px;
        .quantity-label {
          color: #4d4d4d;
          margin-bottom: 6px;
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
        }
        .el-input-number {
          width: 118px !important;
          .el-input-number__decrease,
          .el-input-number__increase {
            height: 30px !important;
            border-radius: 0;
            width: 29px !important;
            background: unset !important;
            i {
              vertical-align: text-top;
              font-weight: 600 !important;
            }
            &:hover {
              color: #606266 !important;
            }
          }
          .el-input {
            line-height: 1 !important;
            .el-input__inner {
              height: 32px !important;
              border-radius: 0px !important;
              font-size: 18px;
              background-color: #ffffff !important ;
              padding: 5px 25px !important;
              border: 1px solid #dcdfe6 !important;
            }
          }
        }
        // input {
        //   width: 223px;
        //   height: 43px;
        //   padding: 8px 10px;
        //   border: none;
        //   background: #f6f6f6;
        //   margin-left: 10px;
        // }
      }
      .product_variants {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        overflow: hidden;
        margin-right: 16px;
        .product_variant {
          width: 33.33333%;
          margin-left: 16px;
          .variant_label {
            display: block;
            max-width: 100%;
            color: #4d4d4d;
            margin-bottom: 6px;
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .variant_wrapper {
            select {
              width: 100%;
              padding: 9px 17px 8px 7px;
              font-size: 12px;
              color: #1a1a1a;
              border-color: #e6e6e6;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              background: #fff url("../../../../../public/images/downward1.png") no-repeat right 5px center;
              background-size:10px;
            }
          }
        }
        .quantity{
          display: none;
          input{
            width: 70px;
            height: 100%;
            padding: 1px 10px;
            border: none;
          }
        }
      }
    }
    // .sm_img {
    //   border: 1px solid #f6f6f6;
    //   width: 54px;
    //   height: 54px;
    //   margin-right: 10px;
    // }
    // .sm_describe {
    //   a {
    //     color: #1890ff;
    //     font-size: 16px;
    //     cursor: pointer;
    //     &:hover {
    //       text-decoration: underline;
    //     }
    //   }
    //   p {
    //     color: #666;
    //     font-size: 14px;
    //     margin: 0;
    //     span:not(:last-child) {
    //       &::after {
    //         content: "/";
    //       }
    //     }
    //   }
    // }
  }
}

// @media screen and (max-width: 575px) {
//   .quickPurchased {

//   }
// }
@media screen and (max-width: 992px) {
  .quickPurchased {
    .container {
      .quick_left {
        max-width: 10%;
        flex: 0 0 10%;
        .quick_left_content {
          display: none;
        }
      }
      .quick_right {
        flex: 0 0 90%;
        max-width: 90%;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .quickPurchased {
    padding: 0;
    .container {
      padding: 0 !important;
      .quick_left {
        display: none;
      }
      .quick_right {
        flex: 0 0 100%;
        max-width: 100%;
        display: block;
        .gocart {
          border-radius: 3px;
          display: block !important;
          height: 50px;
          width: 100%;
          margin: 0 !important;
        }
        .product_variants {
            margin-right: 0;
          .product_variant {
            width: auto;
            flex: 1;
            margin-left: 0;
            .variant_label {
              display: none;
            }
            .variant_wrapper{
              select{
                border: none;
                border-right: 1px solid #e6e6e6;
              }
            }
          }
        }
        .commoditynum {
            display: none;
        }
        .quantity{
          display: block !important;
        }
      }
    }
  }
}
</style>